import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { collectionServices } from '@hero/services';
import { createQueryKey } from '@hero/utils';

export const useUpdateCollection = ({ options = {} } = {}) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ params: { collectionId }, body }) => collectionServices.update(collectionId, body),
    {
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.useGetCollectionsKey] });
        queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.useGetCollectionKey] });
        queryClient.invalidateQueries({
          queryKey: createQueryKey(
            QUERY_KEYS.useGetCollectionProductsKey,
            variables.params.collectionId
          )
        });
      },
      ...options
    }
  );
};
